<app-data-title
	[title]="title"
	[status]="status">
</app-data-title>
@if (segmentedTile == false || segmentedTile == undefined) {
<huge-row style="width: 100%;">
	@for (tile of dataTiles; track tile) {
<mat-col style="width: 100%;">
		<app-data-tile
			[value]="tile.value"
			[valueColor]="tile.valueColor"
			[title]="tile.title"
			[titleColor]="tile.titleColor"
			[subTitle]="tile.subTitle"
			[subTitleColor]="tile.subTitleColor"
			[tileColor]="tile.tileColor"
			[indicatorText]="tile.indicatorText"
			[indicatorIcon]="tile.indicatorIcon"
			[indicatorTextColor]="tile.indicatorTextColor"
			[indicatorIconColor]="tile.indicatorIconColor"
			style="min-height: 100%">
		</app-data-tile>
	</mat-col>
}
</huge-row>
}
@if (segmentedTile == true) {
<huge-row>
	<mat-col style="width: 100%;">
		<app-segmented-data-tile [tileData]="segementedTiles"></app-segmented-data-tile>
	</mat-col>
</huge-row>
}
